import { useQuery } from '@apollo/client';
import { transformErrors } from '@core/adapters/errors';
import { GET_COMMUNITY_GROUPS_WITH_COMMUNITIES } from '@core/components/Guide/graphql';
import type { DomainError } from '@core/domain';
import type { GetCommunityGroupsWithCommunitiesQuery } from '@core/graphql/types/operations';
import { useMemo } from 'react';

/**
 * Fetches all community groups (with nested communities) for the Community Management page.
 *
 * The nested `communities` array on each group is used to disable the delete
 * button for non-empty groups. Server-side 409 remains as a safety net.
 */
export function useCommunityGroupsForDeletion() {
  const { data, loading, error, refetch } = useQuery<GetCommunityGroupsWithCommunitiesQuery>(GET_COMMUNITY_GROUPS_WITH_COMMUNITIES, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const communityGroups = data?.communityGroupsWithCommunities?.communityGroups || [];

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  return {
    communityGroups,
    loading,
    errors,
    refetch,
  };
}
